import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import Chart1 from "./Chart1";
import Chart2 from "./Chart2";
import Chart3 from "./Chart3";
import Chart6 from "./Chart6";
import PieCharts_1_1 from "./PieCharts_1_1";
import PieCharts_1_2 from "./PieCharts_1_2";
import PieCharts_2_1 from "./PieCharts_2_1";
import PieCharts_2_2 from "./PieCharts_2_2";
import PieCharts_3_1 from "./PieCharts_3_1";
import PieCharts_3_2 from "./PieCharts_3_2";
// import { BarChart } from "recharts";
import { BarChart } from "./BarChart";
import { Button, Typography } from "@mui/material";
import Select from "../../ui/PortalSelect";
import axios from "axios";
import Swal from "sweetalert2";
import { baseURL } from "../backend_url";
import { formatDate, formatDate_withTime } from "../commonFunctions";
import { BarCharts } from "./ComposedChart";
import DropChart from "./Drop-off";
import PickUp from "./PickUp";
import Modal from 'react-bootstrap/Modal'
import { EmptyState } from '../../ui'
import { loadAccessibleCompanies, readSessionUser } from '../accountAccess';
// import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
// import BreadCrumb from "./BreadCrumb";

const Dashboard = () => {
  var temp_location_id = "";
  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [locationDetail, setLocationDetail] = useState([{}]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [showingChartOf, setShowingChartOf] = useState("28 days");
  const [showingChartOf2, setShowingChartOf2] = useState("28 days");
  const [reservationDetail_total, setReservationDetail_total] = useState([]);
  const [reservationDetail_valid, setReservationDetail_valid] = useState([]);
  const [reservationDetail_cancelled, setReservationDetail_cancelled] = useState([]);
  const [reservationDetail_noShow, setReservationDetail_noShow] = useState([]);
  const [pickUpDetail, setPickUpDetail] = useState([]);
  const [dropOffDetail, setDropOffDetail] = useState([]);

  const [chartdata1, setChartData1] = useState();
  const [chartdata2, setChartData2] = useState();
  const [chartdata3, setChartData3] = useState();
  const [chartdata4, setChartData4] = useState();
  const [chartdata5, setChartData5] = useState();
  const [chartdata6, setChartData6] = useState();
  const [chartdata7, setChartData7] = useState([]);
  const [barChartInventory, setBarChartInventory] = useState([]);

  //API call
  useEffect(() => {
    const { user, error } = readSessionUser();

    if (error) {
      setLoggedInUserDetail({});
      setcompanyDetail([]);
      return;
    }

    setLoggedInUserDetail(user);
    loadAccessibleCompanies(baseURL, user, "Dashboard_Account Access")
      .then(setcompanyDetail)
      .catch(() => setcompanyDetail([]));
  }, []);


  //Trigger on Company Name Dropdown Changes , getting Company ID
  useEffect(() => {
    if (companyDetail && companyName) {

      setBarChartInventory([]);
      setLocationDetail([]);

      let obj_company_detail = companyDetail.filter(
        (value) => value.company_name === companyName
      )[0];
      let temp_company_id = obj_company_detail._id;
      let company_type = obj_company_detail.account_type;
      setcompany_id(temp_company_id);


      /* Cross-account dashboard aggregation is disabled in the vendor-isolated model.
        //API call for getting data from DB
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        };

        fetch(
          baseURL + "/get_reservations_for_dashboard_all_affiliates",
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {

            // console.log("----data all afflt---");
            // console.log(data);

            let arr1 = data[0];
            let arr2 = data[1];
            let arr3 = data[2];
            let arr4 = data[3];

            setChartData1(arr1);
            setReservationDetail_total(arr1);

            setChartData2(arr2);
            setReservationDetail_valid(arr2);

            setChartData3(arr3);
            setReservationDetail_cancelled(arr3);

            setChartData6(arr4);
            setReservationDetail_noShow(arr4);

          }); //api hit ends



        // Pick Up 
        fetch(
          baseURL + "/get_pickUp_for_dashboard_all_affiliates",
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {

            let arr1 = data;

            setChartData4(arr1);
            setPickUpDetail(arr1);

          }); //Pick up ends


        // DropOff 
        fetch(
          baseURL + "/get_dropOff_for_dashboard_all_affiliates",
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {

            let arr2 = data;

            setChartData5(arr2);
            setDropOffDetail(arr2);


          }); //DropOff up ends
      }
      */
      {

        //API call for getting data from DB
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        };

        fetch(
          baseURL + "/get_company_location/" + temp_company_id
          + "?companyNumber=" + encodeURIComponent(temp_company_id.toString()),
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {
            let allTemp = data.res;
            if (loggedInUserDetail.role_capabilities?.all_modules_access === true) {
              if (allTemp.length > 0) {
                setLocationDetail(allTemp);
                setLocationName("");
                setLocationId("");
              }
            } else {
              axios
                .post(baseURL + "/get_individual_user_details", {
                  user_email: loggedInUserDetail.userEmail,
                  companyNumber: temp_company_id.toString(),
                })
                .then((data) => {
                  if (allTemp.length > 0) {
                    allTemp = allTemp.filter(
                      (val) =>
                        val !== undefined &&
                        data.data[0].location_allocated[val.location_id]
                    );

                    setLocationDetail(allTemp);
                    setLocationName("");
                    setLocationId("");
                  }
                });
            }
          });

        fetch(
          baseURL + "/get_reservations_for_dashboard/" + temp_company_id
          + "?companyNumber=" + encodeURIComponent(temp_company_id.toString()),
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {

            let arr1 = data[0];
            let arr2 = data[1];
            let arr3 = data[2];
            let arr4 = data[3];

            setChartData1(arr1);
            setReservationDetail_total(arr1);

            setChartData2(arr2);
            setReservationDetail_valid(arr2);

            setChartData3(arr3);
            setReservationDetail_cancelled(arr3);

            setChartData6(arr4);
            setReservationDetail_noShow(arr4);

          }); //api hit ends



        // Pick Up 
        fetch(
          baseURL + "/get_pickUp_for_dashboard/" + temp_company_id
          + "?companyNumber=" + encodeURIComponent(temp_company_id.toString()),
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {

            let arr1 = data;

            setChartData4(arr1);
            setPickUpDetail(arr1);

          }); //Pick up ends


        // DropOff 
        fetch(
          baseURL + "/get_dropOff_for_dashboard/" + temp_company_id
          + "?companyNumber=" + encodeURIComponent(temp_company_id.toString()),
          requestOptions
        )
          .then((res) => res.json())
          .then((data) => {

            let arr2 = data;

            setChartData5(arr2);
            setDropOffDetail(arr2);


          }); //DropOff up ends

      }

    } //final if ends here
  }, [companyName]);



  useEffect(() => {
    if (locationName && locationDetail) {
      setChartData1([]);
      setReservationDetail_total([]);
      setChartData2([]);
      setReservationDetail_valid([]);
      setChartData3([]);
      setReservationDetail_cancelled([]);
      setBarChartInventory([])

      temp_location_id = locationDetail
        .filter((loc) => loc.location_name === locationName)
        .map((val) => val.location_id);
      setLocationId(temp_location_id);

      const location_code = temp_location_id.toString().split("-")[1]

      //API call for getting data from DB
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };


      fetch(
        baseURL + "/get_reservations_for_dashboard_for_location/" + company_id + "*" + temp_location_id
        + "?companyNumber=" + encodeURIComponent(company_id.toString()),
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {

          let arr1 = data[0];
          let arr2 = data[1];
          let arr3 = data[2];
          let arr4 = data[3];

          setChartData1(arr1);
          setReservationDetail_total(arr1);

          setChartData2(arr2);
          setReservationDetail_valid(arr2);

          setChartData3(arr3);
          setReservationDetail_cancelled(arr3);

          setChartData6(arr4);
          setReservationDetail_noShow(arr4);

        }); //api hit ends


      // Pick Up 
      fetch(
        baseURL + "/get_pickUp_for_dashboard_for_location/" + company_id + "*" + temp_location_id
        + "?companyNumber=" + encodeURIComponent(company_id.toString()),
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {

          let arr1 = data;

          setChartData4(arr1);
          setPickUpDetail(arr1);


        }); //Pick up ends


      // DropOff 
      fetch(
        baseURL + "/get_dropOff_for_dashboard_for_location/" + company_id + "*" + temp_location_id
        + "?companyNumber=" + encodeURIComponent(company_id.toString()),
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {

          let arr2 = data;

          setChartData5(arr2);
          setDropOffDetail(arr2);


        }); //DropOff up ends

    }
  }, [locationName]);

  //Option for company name
  const companyNameOptions = companyDetail.map((value) => ({
    value: value.company_name,
    label: value.company_name,
  }));

  const handleInputChangeCompanyName = (characterEntered) => {
    setCompanyName(characterEntered.value);
  };
  //Option for Location name
  const locationNameOptions = locationDetail.map((value) => ({
    value: value.location_name,
    label: value.location_name != undefined && value.location_name + " - " + value.location_id.toString().trim().split("-")[1]
  }));

  const handleInputChangeLocationName = (characterEntered) => {
    setLocationName(characterEntered.value);
  };

  // Chart data Button
  function setFirstButton() {
    // let arr1 = [];
    // for (let i = ele1_1.length - 1; i >= 0; i--) {
    //   arr1.push(ele1_1[i]);
    // }
    setChartData1(ele1_1);

    // let arr2 = [];
    // for (let i = ele1_2.length - 1; i >= 0; i--) {
    //   arr2.push(ele1_2[i]);
    // }
    setChartData2(ele1_2);

    // let arr3 = [];
    // for (let i = ele1_3.length - 1; i >= 0; i--) {
    //   arr3.push(ele1_3[i]);
    // }
    setChartData3(ele1_3);

    // let arr4 = [];
    // for (let i = ele1_4.length - 1; i >= 0; i--) {
    //   arr4.push(ele1_4[i]);
    // }
    setChartData6(ele1_4);

    setShowingChartOf("7 days");
  }

  function setSecondButton() {
    // let arr1 = [];
    // for (let i = elem1_1.length - 1; i >= 0; i--) {
    //   arr1.push(elem1_1[i]);
    // }
    setChartData1(elem1_1);

    // let arr2 = [];
    // for (let i = elem1_2.length - 1; i >= 0; i--) {
    //   arr2.push(elem1_2[i]);
    // }
    setChartData2(elem1_2);

    // let arr3 = [];
    // for (let i = elem1_3.length - 1; i >= 0; i--) {
    //   arr3.push(elem1_3[i]);
    // }
    setChartData3(elem1_3);

    // let arr4 = [];
    // for (let i = elem1_4.length - 1; i >= 0; i--) {
    //   arr4.push(elem1_4[i]);
    // }
    setChartData6(elem1_4);
    setShowingChartOf("14 days");
  }

  function setThirdButton() {
    // let arr1 = [];
    // for (let i = elem2_1.length - 1; i >= 0; i--) {
    //   arr1.push(elem2_1[i]);
    // }
    setChartData1(elem2_1);

    // let arr2 = [];
    // for (let i = elem2_2.length - 1; i >= 0; i--) {
    //   arr2.push(elem2_2[i]);
    // }
    setChartData2(elem2_2);

    // let arr3 = [];
    // for (let i = elem2_3.length - 1; i >= 0; i--) {
    //   arr3.push(elem2_3[i]);
    // }
    setChartData3(elem2_3);

    // let arr4 = [];
    // for (let i = elem2_4.length - 1; i >= 0; i--) {
    //   arr4.push(elem2_4[i]);
    // }
    setChartData6(elem2_4);
    setShowingChartOf("28 days");
  }

  const ele1_1 = reservationDetail_total.slice(0, 7);
  const elem1_1 = reservationDetail_total.slice(0, 14);
  const elem2_1 = reservationDetail_total.slice(0, 28);

  const ele1_2 = reservationDetail_valid.slice(0, 7);
  const elem1_2 = reservationDetail_valid.slice(0, 14);
  const elem2_2 = reservationDetail_valid.slice(0, 28);

  const ele1_3 = reservationDetail_cancelled.slice(0, 7);
  const elem1_3 = reservationDetail_cancelled.slice(0, 14);
  const elem2_3 = reservationDetail_cancelled.slice(0, 28);

  const ele1_4 = reservationDetail_noShow.slice(0, 7);
  const elem1_4 = reservationDetail_noShow.slice(0, 14);
  const elem2_4 = reservationDetail_noShow.slice(0, 28);

  // PickUp DropOff Chart data Button
  function setFirstButton1() {
    setChartData4(item1_1);
    setChartData5(item2_1);

    console.log(item1_1)
    console.log(item2_1)
    setShowingChartOf2("7 days");
  }

  function setSecondButton2() {
    setChartData4(item1_2);
    setChartData5(item2_2);
    setShowingChartOf2("14 days");
  }

  function setThirdButton3() {
    setChartData4(item1_3);
    setChartData5(item2_3);
    setShowingChartOf2("28 days");
  }

  const item1_1 = pickUpDetail.slice(0, 7);
  const item1_2 = pickUpDetail.slice(0, 14);
  const item1_3 = pickUpDetail.slice(0, 28);

  const item2_1 = dropOffDetail.slice(0, 7);
  const item2_2 = dropOffDetail.slice(0, 14);
  const item2_3 = dropOffDetail.slice(0, 28);

  const bookingPeriods = [
    { label: "7 days", value: "7 days", action: setFirstButton },
    { label: "14 days", value: "14 days", action: setSecondButton },
    { label: "28 days", value: "28 days", action: setThirdButton },
  ];

  const movementPeriods = [
    { label: "7 days", value: "7 days", action: setFirstButton1 },
    { label: "14 days", value: "14 days", action: setSecondButton2 },
    { label: "28 days", value: "28 days", action: setThirdButton3 },
  ];

  return (
    <main className="container-fluid portal-dashboard">
      <section className="dashboard-hero" aria-labelledby="dashboard-title">
        <div>
          <span className="dashboard-eyebrow">Operations overview</span>
          <Typography id="dashboard-title" variant="h4" component="h1">
            Dashboard
          </Typography>
          <p>Monitor reservation activity and upcoming vehicle movements by vendor and location.</p>
        </div>
        <div className="dashboard-live-badge">
          <span aria-hidden="true" />
          Live workspace
        </div>
      </section>

      <section className="dashboard-filter-panel" aria-labelledby="dashboard-filter-title">
        <div className="dashboard-filter-copy">
          <span className="dashboard-section-kicker">Workspace scope</span>
          <h2 id="dashboard-filter-title">Choose an account and location</h2>
          <p>Dashboard data stays isolated to the vendor account you select.</p>
        </div>
        <div className="dashboard-filter-grid">
          <div className="dashboard-filter-field">
            <label htmlFor="company_name" className="form-label">Account Name</label>
            <Select
              classNamePrefix="portal-select"
              value={{
                value: companyName,
                label: companyName || "Select Account Name",
              }}
              inputId="company_name"
              name="company_name"
              options={companyNameOptions}
              onChange={handleInputChangeCompanyName}
            />
          </div>
          <div className="dashboard-filter-field">
            <label htmlFor="location_name" className="form-label">Location Name</label>
            <Select
              classNamePrefix="portal-select"
              value={{
                value: locationName,
                label: locationName || "Select Location Name",
              }}
              inputId="location_name"
              name="location_name"
              options={locationNameOptions}
              onChange={handleInputChangeLocationName}
            />
          </div>
        </div>
      </section>

      {companyName === "" && (
        <EmptyState
          compact
          title="Choose an account to view dashboard insights"
          description="Select an account and location above to load reservation performance and upcoming vehicle movements."
          className="dashboard-empty-state"
        />
      )}

      {companyName !== "" && (
        <div className="dashboard-insights">
          <section className="dashboard-section" aria-labelledby="reservation-performance-title">
            <div className="dashboard-section-header">
              <div>
                <span className="dashboard-section-kicker">Reservation trends</span>
                <h2 id="reservation-performance-title">Reservation performance</h2>
              </div>
              <div className="dashboard-period-switch" aria-label="Reservation reporting period">
                {bookingPeriods.map((period) => (
                  <button
                    key={period.value}
                    type="button"
                    className={showingChartOf === period.value ? "is-active" : ""}
                    aria-pressed={showingChartOf === period.value}
                    onClick={period.action}
                  >
                    {period.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="dashboard-chart-grid">
              <div className="dashboard-chart-card">
                <Chart1 title={showingChartOf} aspect={2 / 1} chartdata1={chartdata1} />
              </div>
              <div className="dashboard-chart-card">
                <Chart3 title={showingChartOf} aspect={2 / 1} chartdata2={chartdata2} />
              </div>
              <div className="dashboard-chart-card">
                <Chart2 title={showingChartOf} aspect={2 / 1} chartdata3={chartdata3} />
              </div>
              <div className="dashboard-chart-card">
                <Chart6 title={showingChartOf} aspect={2 / 1} chartdata6={chartdata6} />
              </div>
            </div>
          </section>

          <section className="dashboard-section" aria-labelledby="vehicle-movements-title">
            <div className="dashboard-section-header">
              <div>
                <span className="dashboard-section-kicker">Forward view</span>
                <h2 id="vehicle-movements-title">Upcoming vehicle movements</h2>
              </div>
              <div className="dashboard-period-switch" aria-label="Vehicle movement reporting period">
                {movementPeriods.map((period) => (
                  <button
                    key={period.value}
                    type="button"
                    className={showingChartOf2 === period.value ? "is-active" : ""}
                    aria-pressed={showingChartOf2 === period.value}
                    onClick={period.action}
                  >
                    {period.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="dashboard-chart-grid">
              <div className="dashboard-chart-card">
                <PickUp title={showingChartOf2} aspect={2 / 1} chartdata4={chartdata4} />
              </div>
              <div className="dashboard-chart-card">
                <DropChart title={showingChartOf2} aspect={2 / 1} chartdata5={chartdata5} />
              </div>
            </div>
          </section>
        </div>
      )}
    </main>
  );
};

export default Dashboard;
